import {Deserializable} from "./deserializable.model";

export class JobPlaintiff {


job_plaintiff_id: number;
job_plaintiff_name: string;
job_plaintiff_type_id: number;
job_id: number;
job_plaintiff_number: number;
job_plaintiff_type_name: string;




  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobPlaintiff {
    Object.assign(this, input);

    return this;
  }


}



